import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)
console.log(process.env)
const state = {
  cudtomUserPoint: [],
  userMakingPoint: [],
  editChangePoingts: {
    new: [],
    edit: [],
    del: []
  }
}

export default new Vuex.Store({
  state,
  mutations: {
    setCudtomUserPoint(state, res) {
      state.cudtomUserPoint = res
    },
    setUserMakingPoint(state, res) {
      state.userMakingPoint = res
    },
    setCudtomEditPoint(state, res) {
      Object.keys(res).forEach(key => {
        // @ts-ignore
        state.cudtomUserPoint[key] = res[key]
      })
    }
  },
  actions: {
  },
  // modules,
  plugins: [
    new VuexPersistence({
      // storage: window.localStorage,
      reducer: (state) => ({
        cudtomUserPoint: state.cudtomUserPoint,
        editChangePoingts: state.editChangePoingts,
        userMakingPoint: state.userMakingPoint
      })
    }).plugin
  ]
})
